var map = {
	"./fe_backdrop_emblem_ed.png": "681f",
	"./fe_backdrop_emblem_emperor.png": "4c4d",
	"./fe_backdrop_emblem_gaul.png": "4799",
	"./fe_backdrop_emblem_hannibal.png": "fc0f",
	"./fe_backdrop_emblem_invasion.png": "2d89",
	"./fe_backdrop_emblem_original.png": "5bd0",
	"./fe_backdrop_emblem_sparta.png": "a103",
	"./fe_backdrop_emblem_spartan_edition.png": "51b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a66c";